import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";

const ViewModal = ({ id, title, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  var result = data.find((item) => item.client_id === id);
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;

  const isTrans = adminInfo?.id_profile == 2 ? true : false;

  const [activeTab] = useState("1");

  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
   .custom-modal {
 
  overflow-y-auto; /* Enable scrolling if the content overflows */
}
    
    `;

  // function formatDate(dateString) {
  //   if (!dateString) return ""; // Handle empty or undefined input
  //   const date = new Date(dateString);
  //   if (isNaN(date)) return ""; // Handle invalid dates
  //   const day = String(date.getUTCDate()).padStart(2, "0");
  //   const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  //   const year = date.getUTCFullYear();
  //   return `${day}-${month}-${year}`;
  // }
  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 pl-2 pt-2 pb-2 pr-2 w-1/2 rounded-lg"
        isOpen={isViewModalOpen}
        onClose={() => {
          closeModal();
        }}
      >
        <ModalBody className="custom-modal" style={{ margin: "0" }}>
          <div>
            <CommonCloseBtn onClose={closeModal} />
            <h2 className="text-center font-bold text-lg">Booking Details</h2>

            {/* Tab Content */}
            {/* <div className="p-4 overflow-y-scroll"> */}
            {activeTab === "1" && (
              <div
                className="overflow-y-scroll flow-root shadow-sm"
                style={{ maxHeight: "70vh", scrollbarWidth: "thin" }}
              >
                <dl className="border rounded-lg border-gray-100 text-sm dark:text-white m-4">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Booking Id
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.ref_no}
                    </dd>
                  </div>

                  {!isTrans && (
                    <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                      <dt className="font-medium text-gray-900 dark:text-gray-200">
                        Agent Name
                      </dt>
                      <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                        {result?.agentname}
                      </dd>
                    </div>
                  )}
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Booking Type{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.is_online === false ? "Offline" : "Online"}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Agent Reference Id{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.agentref}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Client Name{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.client_name}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Start City{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.arrival}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      End City{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.departure}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Type of Service
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.package_type}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Seller
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.seller}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Start Date
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.start_date}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      End Date
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.end_date}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Booking Status{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.status === 0
                        ? "Confirmed"
                        : result?.status === 1
                          ? "Canceled"
                          : null}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      No of Persons
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {Number(result?.no_of_adult || 0)} Adult(s)
                      {Number(result?.no_of_kids || 0) > 0 && (
                        <> , {Number(result?.no_of_kids)} Child(ren)</>
                      )}
                    </dd>
                  </div>
                  {!isTrans && (
                    <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                      <dt className="font-medium text-gray-900 dark:text-gray-200">
                        Selling Price
                      </dt>
                      <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                        {Math.round(Number(result?.selling_price))}
                      </dd>
                    </div>
                  )}
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Vendor Name
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.vendor_name}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Driver Details
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.driver_name}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Arrival Executive Details
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.arrival_executive}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Departure Executive Details
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.departure_executive}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Itinerary Details
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {/* {result?.itinerary} */}
                      <div
                        dangerouslySetInnerHTML={{ __html: result?.itinerary }}
                      />
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Vehicle Type
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.client_vehicle_name}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      No of Days
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.no_of_days}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Special Note
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {/* {result?.special_note} */}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: result?.special_note,
                        }}
                      />
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Booking Date
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.booking_date}
                    </dd>
                  </div>
                </dl>
              </div>
            )}
            {/* </div> */}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
